import { useQuery } from '@tanstack/react-query';

import { onboardingApi } from '@/api/services/onboarding.api';

import { onboardingKeys } from '../query-keys';
import type { IOnboardingStatus } from '../types';

// Always refetch on mount/focus so a just-completed onboarding step reflects
// promptly when the user returns to the dashboard or checklist. Completing any
// step navigates away from the onboarding surface and back, so remount refetch
// covers every flow without invalidating from each feature's mutation.
const ONBOARDING_STALE_MS = 0;

export function useOnboardingStatus() {
    const query = useQuery<IOnboardingStatus>({
        queryKey: onboardingKeys.status(),
        queryFn: () => onboardingApi.status(),
        staleTime: ONBOARDING_STALE_MS,
        refetchOnWindowFocus: true,
    });
    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch,
    };
}
